module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Braven.dce992d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Braven.jpg
// module id = B3GR
// module chunks = 0